import React, {useEffect, useState, useRef} from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    TextField,
    Select,
    MenuItem,
    InputLabel
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {
    DateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import {IItem} from './Kms';
import usePost from '../hooks/usePost';
import MaterialTable from 'material-table';
import config from '../data/config.json';
import isEmpty from 'lodash.isempty';

const {tableIcons} = require("../muiConsts/tableIcons")

interface IEditProps {
    edit: IItem | null;
    isOpen: boolean;
    close: () => void;
    update: () => void;
}

const defaultEdit = {
    name: '',
    type: '',
    expire: new Date().getTime() / 1000,
    data: {},
}

interface ToDateParams {
    input_date: any;
}

interface ToEpochParams {
    e: any;
}

export default ({isOpen, edit, close, update}: IEditProps) => {
    const tableRef = useRef();
    const [data, setData] = useState<IItem>(edit || defaultEdit);
    const [isDataEdited, setIsDataEdited] = useState(false);
    useEffect(() => {
        setData(edit || defaultEdit);
    }, [edit]);
    const {post} = usePost(`/api/kms/v1/management/${data.name}`);
    const handleOnClick = async () => {
        if (document.querySelector('button[title="Save"]')) {
            alert('Please Save or Cancel Current Edit to Update');
            return
        }
        await post({...data, tableData: undefined})
        setData(defaultEdit);
        update();
        close();
    }
    const toDate = ({input_date}: ToDateParams) => new Date(0).setUTCSeconds(input_date)
    const toEpoch = ({e}: ToEpochParams) => new Date(e).getTime() / 1000
    const handleOnCloseClick = () => {
        setData(defaultEdit);
        close();
    }

    const handleTypeChange = (e: any) => {
        const value: string = e.target.value as string;
        if (value && (config as any)[value] && !isDataEdited) {
            setData({
                ...data,
                type: value,
                data: (config as any)[value].reduce((curr: any, key: string) => {
                    curr[key] = ""
                    return curr;
                }, {})
            })
        } else {
            setData({
                ...data,
                type: value,
            });
        }
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Dialog
                open={isOpen}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle> {edit ? 'Edit Key' : 'New Key'} </DialogTitle>
                <DialogContent>
                    <div>
                        <TextField
                            margin="dense"
                            autoCapitalize="none"
                            onChange={(e) => setData({...data, name: e.currentTarget.value})}
                            fullWidth label="Name"
                            disabled={!!edit}
                            value={data.name}
                        />
                    </div>
                    <div>
                        <InputLabel id="type-select">Type</InputLabel>
                        <Select
                            autoCapitalize="none"
                            labelId="type-select"
                            onChange={handleTypeChange}
                            // onChange={(e) => setData({ ...data, type: toUpper(e.target.value as string) })}
                            fullWidth label="Type" disabled={!!edit} value={data.type}>
                            {Object.keys(config).map(item => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>
                            ))}
                        </Select>
                    </div>
                    <DateTimePicker
                        margin="dense"
                        label="Expire"
                        format="MM/dd/yyyy HH:mm"
                        value={toDate({input_date: data.expire})}
                        onChange={(e) => setData({...data, expire: toEpoch({e: e})})}
                    />
                    <MultiTextBox tableRef={tableRef} value={data.data}
                                  onChange={(value: { [index: string]: string }) => {
                                      setData({...data, data: value});
                                      setIsDataEdited(true);
                                  }}/>

                </DialogContent>

                <DialogActions>
                    <Button disabled={!data.name || !data.type || isEmpty(data.data)} onClick={handleOnClick} color="primary">
                        {edit ? 'Update' : 'Create'}
                    </Button>
                    <Button onClick={handleOnCloseClick} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </MuiPickersUtilsProvider>
    );
};

const EditComponent = ({setEditing, value, onChange}: any) => {
    return (
        <TextField id="edit-key" multiline value={value} onChange={e => onChange(e.target.value)}/>
    )
}

const MultiTextBox = ({value = {'testkey': 'testvalue'}, onChange, setEditing, tableRef}: any) => {
    const data = Object.keys(value).map(key => ({key, value: value[key]}));
    return (
        <MaterialTable
            data={data}
            columns={[
                {
                    title: 'Key', 
                    field: 'key', 
                    validate: rowData => rowData.key === '' ? 'Key cannot be empty' : ''
                },
                {
                    title: 'Value', field: 'value', editComponent: (props) => <EditComponent {...props} setEditing={setEditing}/>
                }
            ]}
            options={{
                showTitle: false,
                search: false,
                actionsColumnIndex: -1,
            }}
            icons={tableIcons}

            editable={{
                isEditable: () => true,
                isDeletable: () => true,
                onRowAdd: async newData => {
                    return onChange({...value, [newData.key]: newData.value})
                },
                onRowUpdate: async (newData, oldData) => {
                    const newVal = {...value};
                    delete newVal[oldData!.key];
                    newVal[newData!.key] = newData.value;
                    return onChange(newVal)
                },
                onRowDelete: async oldData => {
                    const newVal = {...value};
                    delete newVal[oldData!.key];
                    onChange(newVal);
                }

            }}
        />
    );
}
